import FiltersBar from './FiltersBar';
import { withI18n } from 'react-i18next';

export default withI18n()(FiltersBar);
